export const findFixedAssetsHeader = [
    {
        label: "序号",
        prop: "index",
        width: "30",
    },
    {
        label: "固定资产名称",
        prop: "assetsName",
    },
    {
        label: "资产类别",
        prop: "genresName",
    },
    {
        label: "折旧年限",
        prop: "expectYear",
        width: "80",
    },
    {
        label: "折旧起始月份",
        prop: "startUse",
        width: "110",
    },
    {
        label: "固定资产原值",
        prop: "resourceAssets",
        width: "100",
    },
    {
        label: "净残值(净残值率5%)",
        prop: "residualRatio",
        width: "130",
    },
    {
        label: "月折旧额",
        prop: "monthDepreciation",
        width: "80",
    },
    {
        label: "累计折旧额",
        prop: "endDepreciation",
        width: "80",
    },
]
export const assetsTableFiled = ['assetsName','genresName','expectYear','startUse','resourceAssets','residualRatio','monthDepreciation','endDepreciation']
export const payRollTableFiled = ['name','cardNo','postWage','meritPay','subsidy','needPay','pensionInsurance','medicalInsurance','monthTax','houseRent','unemploymentInsurance']
export const AmortizationTableFiled = ['name','period','month','originalValue','monthly','accumulated','remaining']
export const ReimbursementFiled = ['amountSupplemented','billNum','cashier','date',{name:'item',children:['category','expenseItem','money']},'loan','personCharge','refund','reimburser'
,'reviewOpinions','reviewer','verifyAmount']
export const payRollTableHeader = [
    {
        label: "序号",
        prop: "index",
        width: "30",
    },
    {
        label: "姓名",
        prop: "name",
        width: "100",
    },
    {
        label: "身份证号",
        prop: "cardNo",
        width:'160'
    },
    {
        label: "岗位工资",
        prop: "postWage",
    },
    {
        label: "绩效工资",
        prop: "meritPay",
    },
    {
        label: "补贴",
        prop: "subsidy",
    },
    {
        label: "应发工资",
        prop: "needPay",
    },
    {
        label: "扣款部分",
        prop: "shouldDeduction",
        children: [
            {
                label: "社保",
                prop: "pensionInsurance",
            },
            {
                label: "医保",
                prop: "medicalInsurance",
            },
            {
                label:'失业保险',
                prop:'unemploymentInsurance'
            },
            {
                label: "个税",
                prop: "monthTax",
            },
            {
                label: "公积金",
                prop: "houseRent",
            },
        ],
    },
    {
        label: "实发工资",
        disabled:true,
        prop: "netSalary",
    },
    {
        label: "签字",
        prop: "sign",
    },
]

export const AmortizationTableHeader = [
    {
        label: "序号",
        prop: "index",
        width: "30",
    },
    {
        label: "摊销名称",
        prop: "name",
    },
    {
        label: "摊销周期",
        prop: "period",
    },
    {
        label: "已摊销月份",
        prop: "month",
    },
    {
        label: "摊销物原值",
        prop: "originalValue",
    },
    {
        label: "月摊销额",
        prop: "monthly",
    },
    {
        label: "累计摊销额",
        prop: "accumulated",
    },
     {
        label: "剩余摊销额",
        prop: "remaining",
        width:'130px'
    },
]


// WEBPACK FOOTER //
// ./src/assets/js/printTemplate.js